import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { BackArrowIcon } from 'components/elements/Icons';
import { useDeviceDetect, useSettingsTabs } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function SettingsDetails({ children, onClickBack }) {
  const classes = useStyles(Styles);
  const { t } = useTranslation('labels');
  const { isDesktop } = useDeviceDetect();
  const { data: tabs } = useSettingsTabs();
  const history = useHistory();
  const tabName = tabs.find(({ link }) => history.location.pathname === link)?.label;

  return (
    <div className={classes.settingsDetails}>
      {!isDesktop && (
        <div className={classes.header}>
          <button data-testid="back-button" className={classes.backButton} type="button" onClick={onClickBack}>
            <BackArrowIcon />
          </button>
          <Typography className={classes.title} variant="h5" component="h5" noWrap>
            {t(tabName)}
          </Typography>
        </div>
      )}
      {children}
    </div>
  );
}

SettingsDetails.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  onClickBack: PropTypes.func.isRequired,
};

export default SettingsDetails;
